// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('order.afterSalesClaimReports', {
        url: '/aftersalesclaimreports',
        templateUrl: 'main/order/reports/afterSalesClaimReports.tpl.html',
        controller: 'AfterSalesClaimReportsController as vm',
        resolve: {
        }
    });
}

// @ngInject
function AfterSalesClaimReportsController($translate, Rms2ReportsApiService, ToasterService, loadSpinnerService) {
    var vm = this;

    //Variables
    vm.fromDate = new Date();
    vm.fromDate.setDate(vm.fromDate.getDate() - 1);
    vm.toDate = new Date();

    //Methods
    vm.getAfterSalesClaimReport = getAfterSalesClaimReport;

    function getAfterSalesClaimReport() {
        var request = {
            fromDate : vm.fromDate,
            toDate : vm.toDate
        }

        loadSpinnerService.start("mainSpinner");
        Rms2ReportsApiService.getAfterSalesClaimReport(request).then(function(response) {
            console.log(response.data);
            ToasterService.showSuccess("SUCCESS");
        }, function(error) {
            console.log(error);
            ToasterService.showError(error, $translate.instant('common.error'));
        }).finally(function () {
            loadSpinnerService.stop("mainSpinner");
        });
    }
}

angular.module('order.afterSalesClaimReports', [])
    .config(stateConfig)
    .controller('AfterSalesClaimReportsController', AfterSalesClaimReportsController);
